module.exports = __webpack_public_path__ + "static/media/cagliostro-icon.e0b1c718.png";